import axios from "axios";
import { BaseUrl } from "../componentsUpdated/redux/config";

export const Booking = {};

const authToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImNvc2N5cml4MUBob3RtYWlsLmNvbSIsInBhc3N3b3JkIjoiJDJiJDEwJEltaW5BOUpoMlJBMmhlRk5UaHE4SHV4eE9XNUw0TGwyR0g4UU5PVTI0TDE4eGs0bjVGMjIyIiwiaXNBZG1pbiI6dHJ1ZSwiaWF0IjoxNzM3MDA3NDU5LCJleHAiOjE3MzcwMTEwNTl9.gye2n8iKRdQ7uDq6A9qhP5TraFwZ8iMc23SReYtepaw";
Booking.getCountries = async () => {
  const queryParams = {};
  const url = "refs";
  const queryString = new URLSearchParams(queryParams).toString();

  return axios.get(`${BaseUrl}${url}${queryString ? "?" + queryString : ""}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
};

Booking.getCities = ({
  isSelectedCountryId,
  sys_user_id = 160,
  role_id = 5,
}) => {
  const queryParams = {};

  if (sys_user_id) {
    queryParams.sys_user_id = sys_user_id;
  }

  if (role_id) {
    queryParams.role_id = role_id;
  }

  const queryString = new URLSearchParams(queryParams).toString();
  const url = `isoCity/facilityIsoCity/${isSelectedCountryId}`;
  return axios.get(`${BaseUrl}${url}${queryString ? "?" + queryString : ""}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
};

Booking.getCitiesFacilitties = ({
  isSelectedCityId,
  sys_user_id = 160,
  role_id = 5,
}) => {
  const queryParams = {};
  if (sys_user_id) {
    queryParams.sys_user_id = sys_user_id;
  }

  if (role_id) {
    queryParams.role_id = role_id;
  }

  const queryString = new URLSearchParams(queryParams).toString();

  const url = `svcTyp/${isSelectedCityId}`;
  return axios.get(`${BaseUrl}${url}${queryString ? "?" + queryString : ""}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
};

Booking.getServices = ({ svcf_id, sys_user_id = 160, role_id = 5 }) => {
  const queryParams = {};
  if (svcf_id) {
    queryParams.svcf_id = svcf_id;
  }

  if (sys_user_id) {
    queryParams.sys_user_id = sys_user_id;
  }

  if (role_id) {
    queryParams.role_id = role_id;
  }

  const queryString = new URLSearchParams(queryParams).toString();

  const url = "service/svcf";
  return axios.get(`${BaseUrl}${url}${queryString ? "?" + queryString : ""}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
};

Booking.getFacilities = ({
  svc_type_id,
  iso_city_id,
  iso_cntry_id,
  svc_provider_name = "",
  sys_user_id = 160,
  role_id = 5,
}) => {
  const queryParams = {};

  if (sys_user_id || sys_user_id === "") {
    queryParams.sys_user_id = sys_user_id || "";
  }

  if (role_id || role_id === "") {
    queryParams.role_id = role_id || "";
  }

  if (svc_provider_name || svc_provider_name === "") {
    queryParams.svc_provider_name = svc_provider_name || "";
  }

  if (iso_cntry_id || iso_cntry_id === "") {
    queryParams.iso_cntry_id = iso_cntry_id || "";
  }

  if (iso_city_id || iso_city_id === "") {
    queryParams.iso_city_id = iso_city_id || "";
  }

  if (svc_type_id || svc_type_id === "") {
    queryParams.svc_type_id = svc_type_id || "";
  }

  const queryString = new URLSearchParams(queryParams).toString();

  const url = `facility/typCityCntry`;
  return axios.get(`${BaseUrl}${url}${queryString ? "?" + queryString : ""}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
};
